// QR Kiosk v2 — KV2-6 minimal fullscreen image view. Fixed layer above the
// takeover (zIndex 1400), object-fit: contain, tap anywhere / ✕ to close. §3-T4.
// Round-6: PORTALED into the kiosk overlay root — this atom is used inside kv2-enter
// report cards (via ReportFileChip), whose transform animation would otherwise trap its
// `position: fixed` into the card box.
import React from "react";
import { createPortal } from "react-dom";
import { useKioskOverlayRoot } from "../shared/kioskOverlayRoot";

export interface MidasImageViewerProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

export function MidasImageViewer({ src, alt, onClose }: MidasImageViewerProps) {
  const overlayRoot = useKioskOverlayRoot();
  if (!overlayRoot) return null;
  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        background: "rgba(0,0,0,0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        cursor: "zoom-out",
      }}
    >
      <img src={src} alt={alt || ""} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
      <button
        type="button"
        aria-label="close"
        onClick={onClose}
        style={{
          position: "fixed",
          top: "calc(12px + env(safe-area-inset-top))",
          right: 14,
          width: 40,
          height: 40,
          borderRadius: 999,
          border: "none",
          background: "rgba(255,255,255,0.14)",
          color: "var(--card)",
          display: "grid",
          placeItems: "center",
          cursor: "pointer",
        }}
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <path d="M6 6 L18 18" />
          <path d="M18 6 L6 18" />
        </svg>
      </button>
    </div>,
    overlayRoot
  );
}

export default MidasImageViewer;
